export default __webpack_public_path__ + "static/media/icon-pathwayreport_eating.8b99a346.png";